export default __webpack_public_path__ + "static/media/background-site2.704b52a1.jpg";